import { validatePostcode } from './address_helpers';
import { FormattedMessage } from '@alltrails/shared/react-intl';

const validatePaymentForm = (name, value, errors) => {
  switch (name) {
    case 'name':
      if (value.length < 1) {
        errors[name] = <FormattedMessage defaultMessage="Please enter the cardholder's name." />;
      } else if (value.split(' ').length < 2) {
        errors[name] = <FormattedMessage defaultMessage="Cardholder's name must include a valid last name." />;
      } else {
        errors[name] = '';
      }
      break;
    case 'cvv':
      // CardValidator provides a max code size if we want to use it here but for some reason it isn't implemented
      errors[name] = value.length > 4 || value.length < 3 ? <FormattedMessage defaultMessage="Enter CVV Code" /> : '';
      break;
    case 'postalCode':
      errors[name] = !validatePostcode(value, 'INTL') || value.length === 0 ? <FormattedMessage defaultMessage="Invalid postal code" /> : '';
      break;
    default:
      break;
  }

  return { [name]: value, errors };
};

export { validatePaymentForm };
